import { useState, useEffect } from "react"
import { useParams } from 'react-router-dom'

import useJwtDecode from './useJwtDecode'

const useAuth = () => {
  const { organization, project } = useParams()
  const { decodeToken } = useJwtDecode()

  const [profile, setProfile] = useState()
  const [role, setRole] = useState()

  useEffect(() => {
    const run = async() => {
      const userProfile = await decodeToken()
      const userRole = userProfile["permissions"].includes(userProfile["org_name"]) ? "admin" : (!organization || !project) ? null : userProfile['permissions'].filter((i) => i.split(':')[1] === project)[0].split(':')[2]
      
      setProfile(userProfile)
      setRole(userRole)
    }
    
    run()
  }, [project])

  return { profile, role }
}

export default useAuth
